// extracted by mini-css-extract-plugin
export default {"tagsBlock":"styles_tagsBlock__-tgde","tagsTitle":"styles_tagsTitle__fpeBq"};